// src/pages/TrackCreation/Step1.tsx
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTrackCreation } from "../../../../../context/TrackCreationContext";
import { useTranslation } from "react-i18next";
import { QuizCoordinatesProps, RouteParamsWithLanguage } from "../../../../../types/screensTypes";
import Button from "../../../../../components/ui/Button";
import { saveQuiz, getQuizById } from "../../../../../api";
import TitleSubtitle from "../../../../../components/common/TitleSubtitle";
import TextInput from "../../../../../components/ui/TextInput";
import stepStyles from "../../createStep.module.css";

const QuizCoordinates: React.FC<QuizCoordinatesProps> = ({ navigateToNext }) => {
    const { trackData } = useTrackCreation();
    const { quizId, language } = useParams<RouteParamsWithLanguage>();
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const [coordinates, setCoordinates] = useState<string>("");

    // Handler to save quiz coordinates
    const handleSaveQuiz = async (): Promise<void> => {
        const token = localStorage.getItem("token");
        const trackId = trackData.trackId;
        if (!trackId || !quizId || !language) return;
        if (!token) return;

        // Ensure we have two values (latitude and longitude)
        const parts = coordinates.split(",").map((part) => part.trim());
        if (parts.length !== 2 || !parts[0] || !parts[1]) {
            // Optionally, you can alert the user here
            console.error('Please enter valid coordinates in "lat, lng" format.');
            return;
        }

        await saveQuiz({
            token,
            trackId,
            quizId,
            latitude: parseFloat(parts[0]),
            longitude: parseFloat(parts[1]),
        });
        navigateToNext(quizId, language);
    };

    // Fetch quiz coordinates info from API and populate state
    const getQuizInfo = async (trackId: string, quizId: string, lang: string): Promise<void> => {
        const token = localStorage.getItem("token");
        if (!token || !trackId || !quizId || !lang) return;

        const quizInfo = await getQuizById({
            token,
            trackId,
            quizId,
            language: lang,
        });
        const quizPoint = quizInfo?.point;
        if (quizPoint) {
            setCoordinates(`${quizPoint.lat}, ${quizPoint.lng}`);
        }
    };

    useEffect(() => {
        if (quizId && quizId !== "" && quizId !== "null" && trackData.trackId && language) {
            getQuizInfo(trackData.trackId, quizId, language);
        }
    }, [quizId, language, trackData.trackId]);

    return (
        <div className={`${stepStyles.editScreen} ${stepStyles.quizEditScreen}`}>
            <TitleSubtitle title={t("modifyCoordinatesQuiz")} subtitle={""} layout="edit" />
            <div>
                <TextInput
                    placeholder={t("enterCoordinatesLatLng")}
                    value={coordinates}
                    size="small"
                    onChange={(e) => setCoordinates(e.target.value)}
                />
            </div>
            <div className={`${stepStyles.stepButton} ${stepStyles.footer}`}>
                <Button
                    variant="primary"
                    shape="pill"
                    className={stepStyles.continueBtn}
                    label={t("continue")}
                    onClick={handleSaveQuiz}
                />
            </div>
        </div>
    );
};

export default QuizCoordinates;
